import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { StubPage } from '#/components/stub-page'

export const Route = createFileRoute(
  '/_authed/accounts/$accountId/workspaces/$workspaceId/deliverables',
)({
  component: WorkspaceDeliverables,
})

function WorkspaceDeliverables() {
  const { t } = useTranslation()
  return (
    <StubPage
      title={t('workspace.deliverables')}
      description={t('workspace.deliverablesComingSoon')}
    />
  )
}
